export default function getAnOrA(str) {
  return _isVowel(str.charAt(0)) ? 'an' : 'a';
}

function _isVowel(char) {
  let lwr = char.toLowerCase();
  return 'aeiou'.includes(lwr);
}